import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">{aboutData.title}</h2>
        <p className="section-subtitle">了解97影视的使命与承诺</p>

        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center">
            {aboutData.description}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            {aboutData.features.map((feature) => (
              <div
                key={feature.label}
                className="bg-background-50 rounded-lg p-5 border border-background-200/70"
              >
                <h3 className="text-sm font-heading text-primary-600 font-semibold">{feature.label}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{feature.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}